module.exports = __webpack_public_path__ + "static/bolsos-b755cb3fa977a23fbf546b849d6c8cff.png";